import Symbolizer = require("./ol3-symbolizer/format/ol3-symbolizer");
export = Symbolizer;
